import { DropdownOption } from '../../../../shared/components/ui/dropdown/dropdown.component';

export interface VisionboardCurrencyInfo {
  cocu_id: number;
  country_id: number;
}

/** Currency/market options — shared by visionboard reports and dashboard overview. */
export const VISIONBOARD_CURRENCY_OPTIONS: DropdownOption[] = [
  { label: 'United States', shortLabel: 'USD', description: 'US DOLLARS', value: '1', image: 'assets/img/country-flags/America.svg', badge: { text: '$' } },
  { label: 'Canada', shortLabel: 'CAD', description: 'CANADA DOLLARS', value: '3', image: 'assets/img/country-flags/Canada.svg', badge: { text: '$' } },
  { label: 'Australia', shortLabel: 'AUD', description: 'AUSTRALIA DOLLARS', value: '2', image: 'assets/img/country-flags/Australia.svg', badge: { text: '$' } },
  { label: 'New Zealand', shortLabel: 'NZD', description: 'NEW ZEALAND DOLLARS', value: '8', image: 'assets/img/country-flags/Australia.svg', badge: { text: '$' } },
  { label: 'Germany', shortLabel: 'EUR', description: 'EURO', value: '9', image: 'assets/img/country-flags/Germany.svg', badge: { text: '€' } },
  { label: 'Italy', shortLabel: 'EUR', description: 'EURO', value: '10', image: 'assets/img/country-flags/Italy.svg', badge: { text: '€' } },
  { label: 'France', shortLabel: 'EUR', description: 'EURO', value: '11', image: 'assets/img/country-flags/France.svg', badge: { text: '€' } },
  { label: 'Spain', shortLabel: 'EUR', description: 'EURO', value: '12', image: 'assets/img/country-flags/Spain.svg', badge: { text: '€' } },
  { label: 'Japan', shortLabel: 'YEN', description: 'YEN', value: '15', image: 'assets/img/country-flags/Japan.svg', badge: { text: '¥' } },
  { label: 'United Kingdom', shortLabel: 'GBP', description: 'POUND', value: '5', image: 'assets/img/country-flags/United Kingdom.svg', badge: { text: '£' } },
  { label: 'United Kingdom', shortLabel: 'EUR', description: 'EURO', value: '4', image: 'assets/img/country-flags/United Kingdom.svg', badge: { text: '€' } },
  { label: 'Poland', shortLabel: 'PLN', description: 'POLISH ZLOTY', value: '14', image: 'assets/img/country-flags/Poland.svg', badge: { text: 'zł' } },
  { label: 'Poland', shortLabel: 'EUR', description: 'EURO', value: '13', image: 'assets/img/country-flags/Poland.svg', badge: { text: '€' } },
];

const CURRENCY_INFO_MAP: Record<string, VisionboardCurrencyInfo> = {
  '1': { cocu_id: 1, country_id: 1 },
  '2': { cocu_id: 2, country_id: 7 },
  '3': { cocu_id: 3, country_id: 2 },
  '4': { cocu_id: 4, country_id: 5 },
  '5': { cocu_id: 5, country_id: 5 },
  '8': { cocu_id: 8, country_id: 9 },
  '9': { cocu_id: 9, country_id: 10 },
  '10': { cocu_id: 10, country_id: 11 },
  '11': { cocu_id: 11, country_id: 12 },
  '12': { cocu_id: 12, country_id: 13 },
  '13': { cocu_id: 13, country_id: 14 },
  '14': { cocu_id: 14, country_id: 14 },
  '15': { cocu_id: 15, country_id: 15 },
};

export function getVisionboardCurrencyInfo(currencyValue: string): VisionboardCurrencyInfo {
  return CURRENCY_INFO_MAP[currencyValue] ?? CURRENCY_INFO_MAP['1'];
}
